/** 判断是否为常见移动端 UA */
export const isMobileDevice = () => {
  const ua = navigator.userAgent.toLowerCase();
  const agents = [
    'mobile',
    'iphone',
    'ipad',
    'ipod',
    'android',
    'linux',
    'windows phone',
    'blackberry',
  ];
  return agents.some(a => ua.includes(a));
};
